import { isLoggedIn } from '/web/store/api'
import { userStore } from '/web/store'
import { useNavigate } from '@solidjs/router'

export default function Footer() {
  const nav = useNavigate()

  const payments = [
    // {
    //   id: 1,
    //   image: '/images/footer/paypal.svg',
    //   name: 'paypal',
    // },
    {
      id: 2,
      image: '/images/footer/mastercard.svg',
      name: 'mastercard',
    },
    {
      id: 3,
      image: '/images/footer/visa.svg',
      name: 'visa',
    },

    {
      id: 4,
      image: '/images/footer/discover.svg',
      name: 'discover',
    },
  ]

  return (
    <footer class="pb-28 pt-20 lg:pb-20">
      <div class="container relative">
        <div class="wrapper grid">
          {/* top */}
          <div class="top flex flex-col items-center justify-center gap-6 text-center">
            <img src="/images/footer/logo_single.svg" width={50} height={61} alt="logo" />
            <h2 class="title text-3xl font-semibold">CosplayFans</h2>
            <p class="max-w-[721px] text-center text-sm font-normal leading-6 sm:text-[22px] sm:font-medium">
              CosplayFans powers immersive experiences with your favorite cosplay creators, allowing
              users to live chat and view private content.
            </p>
          </div>
          {/* middle */}
          <div class="items footer-links mt-10 grid grid-cols-2 flex-wrap justify-between gap-x-3 gap-y-10 sm:gap-x-6 md:flex">
            {/* item */}
            <div class="item">
              <div class="title">
                <h3>Information</h3>
              </div>
              <ul>
                <li>
                  <button
                    onClick={() => {
                      if (!isLoggedIn()) {
                        userStore.loginModal(true)
                      } else {
                        return nav('/chat/')
                      }
                    }}
                  >
                    Live Chat
                  </button>
                </li>
                <li>
                  <button
                    onClick={() => {
                      userStore.creatorModal(true)
                      userStore.closeSideMenu()
                    }}
                  >
                    Become a Creator
                  </button>
                </li>
                <li>
                  <button
                    onClick={() => {
                      userStore.characterModal(true)
                      userStore.closeSideMenu()
                    }}
                  >
                    Character Requests
                  </button>
                </li>
                <li>
                  <button
                    onClick={() => {
                      if (!isLoggedIn()) {
                        userStore.loginModal(true)
                      } else {
                        return nav('/generate-image/')
                      }
                    }}
                  >
                    Generate Image
                  </button>
                </li>
              </ul>
            </div>
            {/* item */}
            <div class="item">
              <div class="title">
                <h3>Terms</h3>
              </div>
              <ul>
                <li>
                  <a href="/terms-of-use">Terms of Service</a>
                </li>
                <li>
                  <a href="/dmca-policy">DMCA Policy</a>
                </li>
                <li>
                  <a href="/privacy-policy">Privacy Policy</a>
                </li>
                <li>
                  <a href="/18-u-s-c-2257-record-keeping-requirements-exemption-statement">
                    18 U.S.C. 2257 Record-Keeping
                    <br />
                    Requirements Exemption Statement
                  </a>
                </li>
              </ul>
            </div>
            {/* item */}
            <div class="item">
              <div class="title">
                <h3>Contact Us</h3>
              </div>
              <ul>
                <li>
                  <a href="https://www.epoch.com/billing_support/contact" target="_blank">
                    Billing
                  </a>
                </li>
                <li>
                  <a href="/contact-us">Support</a>
                </li>
                <li>
                  <a href="/faq">FAQ's</a>
                </li>
                <li>
                  <a href="/content-removal">Content Removal</a>
                </li>
              </ul>
            </div>
            {/* item */}
            <div class="item">
              <div class="title">
                <h3>Socials</h3>
              </div>
              <ul>
                <li>
                  <a
                    href="https://x.com/cosplayfans__"
                    class="flex items-center gap-2"
                    target="_blank"
                  >
                    <img
                      class=" h-[13px] w-[16px] sm:h-[17px] sm:w-[20px]"
                      width={17}
                      height={17}
                      src="/images/footer/x.svg"
                      alt="x"
                    />
                    <h5 class="text-sm font-normal sm:text-lg">@cosplayfans__</h5>
                  </a>
                </li>
                <li>
                  <a
                    href="https://www.instagram.com/cosplayfansofficial/"
                    class="flex items-center gap-2"
                    target="_blank"
                  >
                    <img
                      class=" h-[16px] w-[16px] sm:h-[20px] sm:w-[20px]"
                      width={20}
                      height={20}
                      src="/images/footer/instagram.svg"
                      alt="instagram"
                    />
                    <h5 class="text-sm font-normal sm:text-lg">@cosplayfansofficial</h5>
                  </a>
                </li>
                <li>
                  <a
                    href="https://www.facebook.com/cosplayfansofficial/"
                    class="flex items-center gap-2"
                    target="_blank"
                  >
                    <img
                      class="h-[16px] w-[16px] brightness-0 invert sm:h-[20px] sm:w-[20px]"
                      width={20}
                      height={20}
                      src="/images/footer/facebook.svg"
                      alt="facebook"
                    />
                    <h5 class="text-sm font-normal sm:text-lg">@cosplayfansofficial</h5>
                  </a>
                </li>
                <li>
                  <a target="_blank" href="/blog">
                    Blog
                  </a>
                </li>
              </ul>
            </div>
          </div>
          {/* bottom */}
          <div class="bottom mt-8 flex flex-col justify-between gap-4 border-t border-white pt-8 md:flex-row">
            <div class="payment-methods images flex justify-center gap-2 md:justify-start">
              {payments.map((payment) => (
                <div class={`img ${payment.name}`}>
                  <img width={1500} height={830} src={payment.image} alt={payment.name} />
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </footer>
  )
}
